// extracted by mini-css-extract-plugin
export default {"table":"table_table__whMCp"};